import AnimatedIcon from 'component/AnimatedIcon'
import Base64Image from 'component/Base64Image'
import styled from 'styled-components'

export const ToolbarElement = styled.div`
  z-index: 100;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  position: absolute;
  gap: calc(1rem / 39 * 16);
  right: calc(1rem / 39 * 8);
  bottom: calc(1rem / 39 * 12);
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.3));
`

export const ToolbarButton = styled.button`
  flex-grow: 1;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
`
export const ToolbarButtonTextGroup = styled.div`
  font-size: calc(1rem / 39 * 14);
  line-height: calc(1rem / 39 * 21);
  text-align: left;
`

export const StyledAnimatedIcon = styled(AnimatedIcon)<{ active?: boolean }>`
  height: calc(1rem / 39 * 40);
  width: calc(1rem / 39 * 40);

  transform: scale(1.3);
`
export const StyledIcon = styled.div<{ $icon: string }>`
  height: 1rem;
  width: 1rem;
  background-image: url(${(props) => props.$icon});
  background-repeat: no-repeat;
  background-size: calc(1rem / 39 * 33) calc(1rem / 39 * 33);
  background-position: center;
`

export const UploaderWrapper = styled.div`
  position: relative;
  width: calc(1rem / 39 * 52);
  height: calc(1rem / 39 * 52);
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid white;
`

export const StyledBase64Img = styled(Base64Image).attrs({
  noLazy: true,
})`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
